module.exports = __webpack_public_path__ + "static/media/intro-end.26f72d11.mp3";